<template>
  <div class="solutions-menu">
    <div class="extended-block">
      <h6>Solutions</h6>
      <menu-item
        path="/about/solutions#digital-engagement"
        text="Digital engagement"
        caption="Leverage our data, network and partnerships across Africa to digitally connect with corporate partners"
        @click="handleItemClick('/about/solutions#digital-engagement')"
      />
      <menu-item
        path="/about/solutions#custom-research"
        text="Custom research"
        caption="Call on our pan-African corporate database and in-country analyst network to conduct market analysis"
        @click="handleItemClick('/about/solutions#custom-research')"
      />
      <menu-item
        path="/about/solutions#compliance-support"
        text="Compliance support"
        caption="Benefit from our access to corporate registries to gather company records at industry-leading turnaround times"
        @click="handleItemClick('/about/solutions#compliance-support')"
      />
    </div>
    <div class="extended-block">
      <h6>Publications</h6>
      <menu-item
        path="/insights/market-insights"
        text="Market Insights"
        caption="Access Asoko's proprietary insights on Africa's private sector"
        @click="handleItemClick('/insights/market-insights')"
      />
      <menu-item
        path="/insights/developments"
        text="Corporate news"
        caption="View the latest news and updates on Asoko’s partnerships, events and opportunities"
        @click="handleItemClick('/insights/developments')"
      />
    </div>
    <div v-if="showProjectsLink" class="extended-block user-block">
      <h6>You and Asoko</h6>
      <user-menu-item
        path="/projects"
        text="My projects"
        caption="Start and manage your custom research projects with Asoko's in-country analyst teams"
        @click="handleItemClick('/projects')"
      />
    </div>
  </div>
</template>

<script>
import MenuItem from './menu-item'
import UserMenuItem from './user-menu-item'
import featureToggles from 'src/settings/feature-toggles'

export default {
  name: 'solutions-menu',
  components: {
    MenuItem,
    UserMenuItem,
  },
  computed: {
    showProjectsLink() {
      return !featureToggles.disableMyProjects
    },
  },
  methods: {
    handleItemClick(path) {
      this.$emit('hide')
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'top-menu-navigate',
        eventLabel: 'Path ' + path,
      })
      this.$gtag.event('top-menu-navigate', {
        'event_category': 'Click',
        'event_label': 'Path ' + path,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.solutions-menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  @include desktop {
    min-width: 800px;
    flex-direction: row;
  }
}
.extended-block {
  padding: $padding-l;
  h6 {
    font-size: $header-label-size;
    font-weight: 600;
    margin-bottom: $margin-m;
    text-transform: uppercase;
    color: $header-secondary-color;
  }
}
.user-block {
  padding: $padding-l;
  background: #fffae9;
}
</style>
